<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

<!--    <div class="row mt-4 mb-4">-->
<!--      <div class="col-lg-9">-->
<!--        <div>-->
<!--          <h4 class="card-title">Фильтры</h4>-->
<!--          <div class="row">-->
<!--          </div>-->
<!--          <div class="row mt-3">-->
<!--            <div class="col-lg-3">-->
<!--              <div class="form-group">-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="col-lg-3 text-right clear-filters">-->
<!--        <div @click="clearAllFilter" class="btn btn-sm btn-secondary">Сбросить фильтры</div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">Партнеры</div>

            <div class="row">
              <div class="col-lg-12">
                <div class="partners--actions">
                  <div class="search">
                    <div class="form-group">
                      <input v-model="searchString" type="text" :placeholder="$t('navbar.search.text')"
                             class="form-control form-control-sm"
                      >
                    </div>
                  </div>
<!--                  <div class="row">-->
<!--                    <div class="col-lg-5">-->
<!--                      <div class="create">-->
<!--                        <div @click="showUploadPartnersFromExcelPopup" class="btn btn-sm btn-success">-->
<!--                          <i class="fas fa-plus"></i> Импорт партнеров из Excel-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="row">-->
<!--                    <div class="col-lg-5">-->
<!--                      <div class="create">-->
<!--                        <div @click="fixDeletedPartners" class="btn btn-sm btn-success">-->
<!--                          <i class="fas fa-plus"></i> Ремонт удаленных партнеров-->
<!--                        </div>-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
                  <div class="row">
                    <div class="col-lg-5">
                      <div class="create">
                        <div @click="showAddPartner" class="btn btn-sm btn-success">
                          <i class="fas fa-plus"></i> {{$t('popularWords.add')}}
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5">
                      <div class="create">
                        <div @click="showPartnerProfitOrderPackageListPopup" class="btn btn-sm btn-info">
                          <i class="fas fa-plus"></i> Пакеты платежек
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-2">
                      <div class="create">
                        <div @click="showEditPayerPopup" class="btn btn-sm btn-success">
                          <i class="fas fa-plus"></i> Реквизиты плательщика
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="row mt-3">
              <div class="col-lg-12">
                <table class="table table-hover" style="cursor: pointer;">
                  <thead>
                  <tr>
                    <th>
                      <b-form-checkbox switch class="mb-1"
                                       value="active" unchecked-value="inactive"
                                       @change="changeTotalStatus($event)"
                      >
                      </b-form-checkbox>
                    </th>
                    <th>
                      <div @click="setOrderBy('status')"
                           :class="{ 'text-primary': this.sortData.status !== null}"
                      >
                        Статус
                        {{
                          sortData.status === 'asc' ? '[1-9]'
                              : sortData.status === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>
                      <div @click="setOrderBy('partner_id')"
                           :class="{ 'text-primary': this.sortData.partner_id !== null}"
                      >
                        ID договора
                        {{
                          sortData.partner_id === 'asc' ? '[1-9]'
                              : sortData.partner_id === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>Глав. юр.лицо</th>
                    <th>
                      <div @click="setOrderBy('slave_legal_person')"
                           :class="{ 'text-primary': this.sortData.slave_legal_person !== null}"
                      >
                        Партнер
                        {{
                          sortData.slave_legal_person === 'asc' ? '[1-9]'
                              : sortData.slave_legal_person === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>
                      <div @click="setOrderBy('contract_number')"
                           :class="{ 'text-primary': this.sortData.contract_number !== null}"
                      >
                        Номер договора
                        {{
                          sortData.contract_number === 'asc' ? '[1-9]'
                              : sortData.contract_number === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>
                      <div @click="setOrderBy('contract_date')"
                           :class="{ 'text-primary': this.sortData.contract_date !== null}"
                      >
                        Дата договора
                        {{
                          sortData.contract_date === 'asc' ? '[1-9]'
                              : sortData.contract_date === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>
                      <div @click="setOrderBy('updated_at')"
                           :class="{ 'text-primary': this.sortData.updated_at !== null}"
                      >
                        Время редактирования
                        {{
                          sortData.updated_at === 'asc' ? '[1-9]'
                              : sortData.updated_at === 'desc' ? '[9-1]'
                                  : ''
                        }}
                      </div>
                    </th>
                    <th>Действия</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in filteredList" :key="item.id" :value="item.id"
                      :class="{ 'table-danger': item.hasFreePrinters === 'has', 'table-primary': !item.withPrinters}"
                  >
                    <td>
                      <b-form-checkbox v-model="item.status" switch class="mb-1"
                                       value="active" unchecked-value="inactive"
                                       @change="changeSingleStatus(item, $event)"
                      >
                      </b-form-checkbox>
                    </td>
                    <td>
                      {{
                        item.status === 'active' ? 'активный'
                            : item.status === 'inactive' ? 'деактивирован'
                                : 'не определен'
                      }}
                    </td>
                    <td>{{item.id}}</td> <!-- на самом деле партнер это и есть договор. Поэтому, просто id -->
                    <td>{{item.franchiseRelation.legalMain.legal_person_name}}</td>
                    <td>
                      <div class="btn btn-sm btn-outline-info"
                           @click="showEditPartnerPopup(item)"
                      >
                        {{item.franchiseRelation.legalSlave.legal_person_name}}
                      </div>
                    </td>
                    <td>{{item.contract_number}}</td>
                    <td>{{item.contract_date ? new Date(item.contract_date).toLocaleDateString('ru-RU') : ''}}</td>
                    <td>{{item.updated_at ? new Date(item.updated_at * 1000).toLocaleString('ru-RU') : ''}}</td>
                    <td>
                      <div class="button-items">
                        <div @click="showManagePartnerPrinters(
                            item.id
                            , item.franchise_relation_id
                            , item.franchiseRelation.legalMain.legal_person_name + '<-->'
                              + item.franchiseRelation.legalSlave.legal_person_name
                        )" class="btn btn-sm btn-outline-info">
                          Принтеры
                        </div>
                        <div @click="showPartnerProfitOrderList(
                            item.id
                            , item.franchiseRelation.legalMain.legal_person_name
                              + '<-->'
                              + item.franchiseRelation.legalSlave.legal_person_name
                            , item.contract_date
                            , item.contract_number
                        )" class="btn btn-sm btn-outline-info">
                          <i class="fas fa-ticket"></i> Платежки
                        </div>
<!--                        <div @click="showPartnerPrimaryDocsListPopup(item)" class="btn btn-sm btn-outline-success">-->
<!--                          <i class="fas fa-ticket"></i> Документы-->
<!--                        </div>-->
                        <div @click="showDeletePartnerPopup(item)" class="btn btn-sm btn-outline-danger">
                          <i class="fas fa-ticket"></i> Удалить
                        </div>
                    </div>
                  </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

    <popup
        :closeButton="addPartnerPopup.closeButton"
        :actionButton="addPartnerPopup.actionButton"
        :actionClass="addPartnerPopup.actionClass"
        :show="addPartnerPopup.show"
        @closePopup="closeAddPopup"
        @actionPopup="addPopupSubmit"
    >
      <div slot="header">Создание нового партнера</div>
      <div slot="body">
        <create-partner ref="myChildCreatePartnerData"
            :submit-partner="submitCreatePartner"
            @submitCreatePartner="createPartner"
        ></create-partner>
      </div>
    </popup>

    <popup
        :closeButton="managePartnerPrintersPopup.closeButton"
        :actionButton="managePartnerPrintersPopup.actionButton"
        :actionClass="managePartnerPrintersPopup.actionClass"
        :show="managePartnerPrintersPopup.show"
        :size="'lg'"
        @closePopup="closeManagePartnerPrintersPopup"
    >
      <div slot="header">Привязка принтеров</div>
      <div slot="body">
        <PossiblePrintersForPartner  ref="myChildPossiblePrintersForPartner"></PossiblePrintersForPartner>
      </div>
    </popup>

    <popup
        :closeButton="partnerProfitOrderList.closeButton"
        :actionButton="partnerProfitOrderList.actionButton"
        :actionClass="partnerProfitOrderList.actionClass"
        :show="partnerProfitOrderList.show"
        :size="'xl'"
        @closePopup="closePartnerProfitOrderList"
        @actionPopup="addPartnerProfitOrder"
    >
      <div slot="header">Платежные поручения</div>
      <div slot="body">
        <PartnerProfitOrdersList  ref="myChildPartnerProfitOrderList"></PartnerProfitOrdersList>
      </div>
    </popup>

    <popup
        :closeButton="editPartnerPopup.closeButton"
        :actionButton="editPartnerPopup.actionButton"
        :actionClass="editPartnerPopup.actionClass"
        :show="editPartnerPopup.show"
        @closePopup="closeEditPartnerPopup"
        @actionPopup="submitEditPartner"
    >
      <div slot="header">Редактирование партнера</div>
      <div slot="body">
        <EditPartner  ref="myChildEditPartner"
                      @partner-was-edited="eventPartnerWasEdited"
        ></EditPartner>
      </div>
    </popup>

    <popup
        :closeButton="editPayerPopup.closeButton"
        :actionButton="editPayerPopup.actionButton"
        :actionClass="editPayerPopup.actionClass"
        :show="editPayerPopup.show"
        @closePopup="closeEditPayerPopup"
        @actionPopup="submitEditPayerPopup"
    >
      <div slot="header">Редактирование реквизитов плательщика</div>
      <div slot="body">
        <EditPayer  ref="myChildEditPayer"></EditPayer>
      </div>
    </popup>

    <popup
        :closeButton="partnerProfitOrderPackageList.closeButton"
        :show="partnerProfitOrderPackageList.show"
        :size="'xl'"
        @closePopup="closePartnerProfitOrderPackageListPopup"
    >
      <div slot="header">Пакеты платежек</div>
      <div slot="body">
        <PartnerProfitOrderPackageList  ref="myChildOrderPackagesList"></PartnerProfitOrderPackageList>
      </div>
    </popup>

    <popup
        :closeButton="uploadPartnersFromExcelPopup.closeButton"
        :show="uploadPartnersFromExcelPopup.show"
        :size="'xl'"
        @closePopup="closeUploadPartnersFromExcelPopup"
        @actionPopup="submitUploadFile"
    >
      <div slot="header">Импорт партнеров из Excel</div>
      <div slot="body">
        <UploadPartnersFromExcel  ref="myChildUploadPartnersFromExcel"></UploadPartnersFromExcel>
      </div>
    </popup>

    <popup
        :closeButton="deletePartnerPopup.closeButton"
        :actionButton="deletePartnerPopup.actionButton"
        :actionClass="deletePartnerPopup.actionClass"
        :show="deletePartnerPopup.show"
        @closePopup="closeDeletePartnerPopup"
        @actionPopup="confirmDeletePartner"
    >
      <div slot="header">Вы действительно хотите удалить партнера?</div>
      <div slot="body">
        <DeletePartner
            ref="myChildDeletePartner"
            @partner-deleted="eventPartnerDeleted"
        >
        </DeletePartner>
      </div>
    </popup>

    <popup
        :closeButton="partnerPrimaryDocsListPopup.closeButton"
        :show="partnerPrimaryDocsListPopup.show"
        @closePopup="closePartnerPrimaryDocsListPopup"
    >
      <div slot="header">Первичные документы партнера</div>
      <div slot="body">
        <PartnerPrimaryDocsList
            ref="myChildPartnerPrimaryDocs"
        >
        </PartnerPrimaryDocsList>
      </div>
    </popup>

  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Popup from "@/components/Popup.vue";
import CreatePartner from "@/components/management/partners/CreatePartner.vue";
import PossiblePrintersForPartner from "@/components/management/partners/PossiblePrintersForPartner.vue";
import EditPartner from "@/components/management/partners/EditPartner.vue";
import CopyArrayAndObject from "@/components/libraries/CopyArrayAndObject";
import PartnerProfitOrdersList from "@/components/management/partners/PartnerProfitOrderList.vue";
import EditPayer from "@/components/management/partners/EditPayer.vue";
import PartnerProfitOrderPackageList from "@/components/management/partners/PartnerProfitOrderPackageList.vue";
import UploadPartnersFromExcel from "@/components/management/partners/UploadPartnersFromExcel.vue";
import DeletePartner from "@/components/management/partners/DeletePartner.vue";
import PartnerPrimaryDocsList from "@/components/management/partners/PartnerPrimaryDocsList.vue";

const copyArrObj = new CopyArrayAndObject();

/**
 * Partners component
 */
export default {
  components: {
    UploadPartnersFromExcel,
    EditPayer,
    PartnerProfitOrdersList,
    EditPartner,
    CreatePartner,
    PossiblePrintersForPartner,
    Popup,
    Layout,
    PageHeader,
    PartnerProfitOrderPackageList,
    DeletePartner,
    PartnerPrimaryDocsList,
  },
  data() {
    return {
      currentSortConditionName: null,
      sortData: {
        partner_id: null,
        slave_legal_person: null,
        status: null,
        contract_number: null,
        contract_date: null,
        updated_at: null,
      },
      partners: [
        {
          withPrinters: 'no',
          hasFreePrinters: 'no',
          id: null,
          franchise_relation_id: null,
          franchiseRelation: {
            legalMain: {
              legal_person_name:  ""
            },
            legalSlave: {
              legal_person_name:  ""
            },
          },
          contract_number: null,
          contract_date: null,
          updated_at: null,
          status: null,
        }
      ],
      hasFreePrinters: 'no',
      currentFranchiseRelationId: null,
      searchString: '',
      editPartner: {},

      uploadPartnersFromExcelPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },

      partnerPrimaryDocsListPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
      },

      partnerProfitOrderPackageList: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },

      partnerProfitOrderList: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },

      managePartnerPrintersPopup: {
        show: false,
        actionButton: null,
        closeButton: this.$t('popularWords.close'),
        actionClass: "btn-success"
      },
      addPartnerPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.add'),
        actionClass: "btn-success"
      },
      deletePartnerPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.delete'),
        actionClass: "btn-success"
      },
      editPartnerPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.save'),
        actionClass: "btn-success"
      },
      editPayerPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.save'),
        actionClass: "btn-success"
      },
      removePartnerPopup: {
        show: false,
        closeButton: this.$t('popularWords.close'),
        actionButton: this.$t('popularWords.confirm'),
        actionClass: "btn-success"
      },
      showNotesPopup: {
        show: false,
        closeButton: this.$t('popularWords.close')
      },
      submitCreatePartner: 0,
      submitManagePartnerPrinters: 0,
      clickedNotes: "",
      blockFilterWatch: false,
      searchStrTimeout: false,
      submitted: false,
      title: this.$t('menuitems.management.list.partners'),
      items: [
        {
          text: this.$t('menuitems.management.text'),
        },
        {
          text: this.$t('menuitems.management.list.partners'),
          active: true
        }
      ],
    };
  },
  validations: {

  },
  computed: {
    filteredList() {
      return this.partners.filter(item =>
          item.franchiseRelation.legalSlave.legal_person_name.toLowerCase().includes(this.searchString.toLowerCase())
      );
    }
  },
  methods: {
    getPartners(sortConditionName){
      let uri = `/v1/partners/get-with-franchise-relations`;
      if ((
            sortConditionName === null
          || sortConditionName === undefined
          )
          && this.currentSortConditionName !== null
      ) {
        sortConditionName = this.currentSortConditionName;
      }
      if (sortConditionName !== null) {
        uri = uri + `?sort=${sortConditionName}`;
      }
      axios
          .get(uri)
          .then(resp => {
            this.partners = resp.data;
            // this.getFreePrintersInfo();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    getFreePrintersInfo() {
      axios
          .get(`/v1/partners/get-free-printers-info`)
          .then(resp => {
            this.partners.forEach(
                function(item, index, sourceArray){
                  if (resp.data[item.id] !== undefined) {
                    sourceArray[index].hasFreePrinters = 'has';
                  } else {
                    sourceArray[index].hasFreePrinters = 'no';
                  }
                }
            );
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    createPartner(data){
      let formData = new FormData();
      for(let key in data){
        if (data[key] === null) {
          continue;
        }
        if( typeof data[key] === 'object'){
          formData.append(key, JSON.stringify(data[key]));
        }else{
          formData.append(key, data[key]);
        }
      }
      axios
          .post(`/v1/partners/add`, formData)
          .then(() => {
            this.closeAddPopup();
            this.getPartners();
            this.$store.dispatch("addNotification", {
              text: this.$t('popularWords.successfully'),
              time: 3,
              color: "success"
            });
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          });
    },
    async clearAllFilter(){
      this.blockFilterWatch = true;
      this.filterType = '';
      this.searchString = '';
      await this.loadList().then(() => {
        this.blockFilterWatch = false;
      });
    },
    closeShowNotesPopup(){
      this.showNotesPopup.show = false;
    },
    showShowNotesPopup(notes){
      this.clickedNotes = notes;
      this.showNotesPopup.show = true;
    },
    closeAddPopup(){
      this.addPartnerPopup.show = false;
    },
    showAddPartner(){
      this.$refs.myChildCreatePartnerData.initFormData();
      this.$refs.myChildCreatePartnerData.getFranchiseRelationList();
      this.addPartnerPopup.show = true;
    },
    addPopupSubmit(){
      this.submitCreatePartner++;
    },
    showManagePartnerPrinters(currentPartnerId, franchiseRelationId, franchiseRelationTitle = null){
      this.$refs.myChildPossiblePrintersForPartner.setNullPrintersData();
      this.$refs.myChildPossiblePrintersForPartner.getFranchiseRelationPrintersByPartnerId(currentPartnerId, franchiseRelationId, franchiseRelationTitle);
      this.managePartnerPrintersPopup.show = true;
    },
    closeManagePartnerPrintersPopup(){
      this.$refs.myChildPossiblePrintersForPartner.setNullPrintersData();
      this.getPartners();
      this.managePartnerPrintersPopup.show = false;
    },
    showPartnerProfitOrderList(partnerId, partnerTitle, contractDate, contractNumber){
      this.$refs.myChildPartnerProfitOrderList.setNullPartnerData();
      this.$refs.myChildPartnerProfitOrderList.currentPartner = {
        id: partnerId,
        title: partnerTitle,
        contractDate: contractDate,
        contractNumber: contractNumber
      };
      this.$refs.myChildPartnerProfitOrderList.getPartnerProfitOrders();
      this.partnerProfitOrderList.show =true;
    },
    closePartnerProfitOrderList(){
      this.$refs.myChildPartnerProfitOrderList.setNullPartnerData();
      this.$refs.myChildPartnerProfitOrderList.setNullOrderList();
      this.partnerProfitOrderList.show =false;
    },
    showEditPartnerPopup(partner){
      this.$refs.myChildEditPartner.setNullFormData();
      this.$refs.myChildEditPartner.getPartnerData(
          partner.id
          , partner.franchiseRelation.legalMain.legal_person_name
          + '<-->'
          + partner.franchiseRelation.legalSlave.legal_person_name
      )
      this.editPartnerPopup.show = true;
    },
    closeEditPartnerPopup(){
      this.$refs.myChildEditPartner.setNullFormData();
      this.editPartnerPopup.show  =false;
    },
    showEditPayerPopup(){
      this.$refs.myChildEditPayer.getPayerData();
      this.editPayerPopup.show = true;
    },
    closeEditPayerPopup(){
      this.editPayerPopup.show = false;
      this.$refs.myChildEditPayer.setNullFormData();
    },
    showPartnerProfitOrderPackageListPopup(){
      // Вписываем в дочку инфу о наличии свободных принтеров
      this.$refs.myChildOrderPackagesList.hasFreePrinters
          = this.partners.find(partner => partner['hasFreePrinters'] === 'has') !== undefined;

      this.$refs.myChildOrderPackagesList.getPackagesData();
      this.partnerProfitOrderPackageList.show = true;
    },
    closePartnerProfitOrderPackageListPopup(){
      this.partnerProfitOrderPackageList.show = false;
    },
    submitEditPayerPopup() {
      this.$refs.myChildEditPayer.setPayerData();
      this.editPayerPopup.show = false;
    },
    submitEditPartner(){
      this.$refs.myChildEditPartner.saveEditPartner();
    },
    eventPartnerWasEdited() {
      this.getPartners();
      this.editPartnerPopup.show =false;
    },
    submitUploadFile() {

    },
    addPartnerProfitOrder(){
      this.$refs.myChildPartnerProfitOrderList.showCreatePartnerProfitOrder();
    },
    showUploadPartnersFromExcelPopup() {
      this.uploadPartnersFromExcelPopup.show = true;
    },
    // async fixDeletedPartners() {
    //   if(confirm('Запустить ремонт удаленных партнеров?')) {
    //     axios
    //         .post(`/v1/partners/fix-deleted-partners`)
    //         .then(resp => {
    //               alert('Обработано ' + resp.data + ' удаленных партнеров');
    //             }
    //         )
    //         .catch(err => {
    //           this.$store.dispatch("addNotification", {
    //             text: err.response.data.message,
    //             time: 6,
    //             color: "danger"
    //           });
    //         })
    //     ;
    //   }
    // },
    closeUploadPartnersFromExcelPopup() {
      this.uploadPartnersFromExcelPopup.show = false;
    },
    showDeletePartnerPopup(currentPartner) {
      this.$refs.myChildDeletePartner.setFormData(
          currentPartner.id
          , currentPartner.franchiseRelation.legalMain.legal_person_name
          , currentPartner.franchiseRelation.legalSlave.legal_person_name
      );
      this.deletePartnerPopup.show = true;
    },
    closeDeletePartnerPopup() {
      this.deletePartnerPopup.show = false;
    },
    confirmDeletePartner() {
      this.$refs.myChildDeletePartner.deletePartner()
    },
    eventPartnerDeleted () {
      this.getPartners();
      this.closeDeletePartnerPopup();
    },

    /**
     * Устанавливает новый статус партнера
     *
     * @param currentPartner
     * @param newStatus
     */
    changeSingleStatus(currentPartner, newStatus) {
      if (newStatus !== 'active' && newStatus !== 'inactive') {
        return;
      }
      let uri = '/v1/partners/single-set-' + newStatus + '-status'
      let formData = new FormData();
      formData.append('id', currentPartner.id);
      axios
          .post(uri, formData)
          .then(resp => {
            currentPartner.status = resp.data['status'];
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    changeTotalStatus(newStatus) {
      if (newStatus !== 'active' && newStatus !== 'inactive') {
        return;
      }
      let uri = '/v1/partners/total-set-' + newStatus + '-status'
      let formData = new FormData();
      formData.append('new_status', newStatus);
      axios
          .post(uri, formData)
          .then(resp => {
            this.getPartners();
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          })
      ;
    },
    setOrderBy(condition) {

      let newValue;
      if (this.sortData[condition] === 'asc') {
        newValue = 'desc';
      } else {
        newValue = 'asc';
      }

      for (let key in this.sortData) {
        this.sortData[key] = null;
      }
      this.sortData[condition] = newValue;
      this.currentSortConditionName = condition + '_' + newValue;
      this.getPartners(this.currentSortConditionName);
    },
    showPartnerPrimaryDocsListPopup(partner) {
      this.$refs.myChildPartnerPrimaryDocs.getPrimaryDocsData(partner);
      this.partnerPrimaryDocsListPopup.show = true;
    },
    closePartnerPrimaryDocsListPopup(partner) {
      this.partnerPrimaryDocsListPopup.show = false;
      this.$refs.myChildPartnerPrimaryDocs.setNullFormData();
    },
  },
  created() {
    this.getPartners();
  },
};
</script>

<style scoped lang="scss">
  .search{
    margin-right: 15px;
  }
</style>
